export const OverflowMenuStorefrontPreviewComponentModule = angular
    .module('app.components.pageHeader.overflowMenuStorefrontPreview', [])
    .component('overflowMenuStorefrontPreview', {
        template: `
            <md-menu-item>
                <md-button open-storefront-slider>{{'BUTTON.STOREFRONTPREVIEW' | translate}}</md-button>
            </md-menu-item>
        `
    }).name;


// WEBPACK FOOTER //
// ./src/app/components/pageHeader/overflowMenu/overflowMenuStorefrontPreview.js